import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getFilesForKnowledgeBase } from '../../../app/services/apiEndpoints';

interface IFetchKBFilesPayload {
    group: string;
    index: string;
    kb: string;
}

export const fetchFilesForKnowledgeBase = createAsyncThunk(
    'kbFiles/fetchKnowledgeBaseFiles',
    async (payload: IFetchKBFilesPayload, thunkAPI) => {
      try {
        const queryParams = new URLSearchParams({
            group: payload.group,
            index: payload.index,
            kb: payload.kb
        });
        const response = await getFilesForKnowledgeBase(queryParams);
        return response;
      } catch (error) {
        const errorMessage =
          error instanceof Error ? error.message : "An unknown error occurred";
        return thunkAPI.rejectWithValue(errorMessage);
      }
    }   
);

interface IKBFileListState {
    kbFiles: any;
    loading: boolean;
    error: any | null;
}

const initialState: IKBFileListState = {
    kbFiles: null,
    loading: true,
    error: null
  };

const KBFilesSlice = createSlice({
  name: 'kb-filelist',
  initialState,
  reducers: {
      setLoading(state, action) {
          state.loading = action.payload;
      },
      clearFileList(state) {
          state.kbFiles = null;
      }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFilesForKnowledgeBase.pending, (state) => {
          state.loading = true;
      })
      .addCase(fetchFilesForKnowledgeBase.fulfilled, (state, action) => {
          state.kbFiles = action.payload;
          state.loading = false;
        })
      .addCase(fetchFilesForKnowledgeBase.rejected, (state, action) => {
          state.error = action.payload as string ?? null;
          state.loading = false;
      })
  },
});
  
export const { setLoading, clearFileList } = KBFilesSlice.actions 
export default KBFilesSlice.reducer;